import {
  type PreferredInputDevice,
  resolvePreferredInputDeviceId,
  SYSTEM_DEFAULT_PREFERRED_INPUT_DEVICE,
} from '@/lib/meetings/transcription-input-device';

import type { MeetingTranscriptionInputDevicesPayload } from '@electron/shared/meetings.types';

// Sentinel for the System Default option so its picker value is a non-empty string
export const SYSTEM_DEFAULT_OPTION_VALUE = '__system_default__';

export function toOptionValue(
  pref: PreferredInputDevice,
  state: MeetingTranscriptionInputDevicesPayload | null
): string {
  return (
    resolvePreferredInputDeviceId(pref, state) ?? SYSTEM_DEFAULT_OPTION_VALUE
  );
}

export function fromOptionValue(value: string): PreferredInputDevice {
  return value === SYSTEM_DEFAULT_OPTION_VALUE
    ? SYSTEM_DEFAULT_PREFERRED_INPUT_DEVICE
    : { type: 'specific_device', deviceId: value };
}
